import { Component } from '@angular/core';

@Component({
  selector: 'app-what-is-capitec',
  templateUrl: './what-is-capitec.component.html',
  styleUrls: ['./what-is-capitec.component.scss']
})
export class WhatIsCapitecComponent{
}
